(function (window) {
  const parallax = document.querySelectorAll('.ukiyo');

  new Ukiyo(parallax, {
    scale: 1.5, // 1~2 is recommended
    speed: 1.5, // 1~2 is recommended
    willChange: true,
  });

  new Ukiyo('.hero-media.parallax', {
    scale: 1.1, // 1~2 is recommended
    speed: 2, // 1~2 is recommended
    willChange: true,
  });

  new Ukiyo('.ukiyo-product', {
    scale: 1.1, // 1~2 is recommended
    speed: 6, // 1~2 is recommended
    willChange: true,
  });
})(window);
